import React from 'react';
import {MasterLayout} from 'layout';
import {TongHopKetQua} from 'modules/thong-ke-bao-cao';

class TongHopKetQuaThanhTraHanhChinhPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <TongHopKetQua type='THANH_TRA_HANH_CHINH'/>
      </MasterLayout>
    );
  }
}

export default TongHopKetQuaThanhTraHanhChinhPage;


// WEBPACK FOOTER //
// ./src/components/pages/thong-ke-bao-cao/TongHopKetQuaThanhTraHanhChinhPage.jsx